import { offlineQueue } from './offline-queue.service';

const PENDING_PREFIX = 'pending-';

export interface PendingAdvancePayload {
  local_id: string;
  project_id: string;
  project_name?: string;
  week_number: number;
  year: number;
  week_start: number;
  week_end: number;
  description?: string;
  progress_percentage: number;
  contractor_specialty?: string;
  photos: string[];
  created_at: number;
}

export const offlineAdvanceService = {
  async saveLocal(payload: Omit<PendingAdvancePayload, 'local_id' | 'created_at'>): Promise<string> {
    const localId = `${PENDING_PREFIX}${crypto.randomUUID()}`;
    const fullPayload: PendingAdvancePayload = {
      ...payload,
      local_id: localId,
      created_at: Date.now(),
    };
    await offlineQueue.enqueue('advance', 'create', fullPayload, localId);
    return localId;
  },

  async listLocalPending(): Promise<PendingAdvancePayload[]> {
    const all = await offlineQueue.listByEntity('advance');
    return all
      .filter((i) => i.status === 'pending' || i.status === 'failed')
      .map((i) => i.payload as PendingAdvancePayload);
  },
};